import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { IAnyos, IPeriodos } from 'src/app/interfaces/portal-calificaciones';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { IPaginacion, ISeccionesReq, ISeccionesRes, ObjSeccion, TmpDataSecciones } from 'src/app/interfaces/secciones';
import { IDocentesReq, ObjDocente, TmpDataDocentes } from 'src/app/interfaces/docentes';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-view-acceso-portal-notas',
  templateUrl: './view-acceso-portal-notas.component.html',
  styleUrls: ['./view-acceso-portal-notas.component.scss']
})

export class ViewAccesoPortalNotasComponent {
  filtroAnyo: number = 0
  filtroPeriodo: number = 0
  filtroSede: number = 0
  filtroSeccion: number | undefined = undefined
  filtroIdDocente: string | undefined = undefined

  listaAnyo: Array<number> = []
  listaPeriodo: any = []
  listaSede: any = []
  listaSeccion: any = []

  filtrosCargados: any = {}

  tieneErrores: any = {}
  submitted: boolean = false

  listaNombreDocentes: any = []

  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    seccion: ['0'],
    idDocente: [''],
    nombreDocente: ['']
  })

  // cambio filtro secciones
  searchValueSecciones: string = '';
  seccionesPaginacion: IPaginacion = {
    pageSize: 500,
    currPage: 1,
    totalPages: 1,
    totalItems: 0
  }
  tmpSecciones: TmpDataSecciones = {
    seccionesPaginacion: {
      pageSize: 500,
      currPage: 1,
      totalPages: 1,
      totalItems: 0
    },
    listado: []
  }
  loadingSecciones: boolean = false

  // Cambio filtro docentes
  searchValueDocentes: string = '';
  docentesPaginacion: IPaginacion = {
    pageSize: 100,
    currPage: 1,
    totalPages: 1,
    totalItems: 0
  }
  tmpDocentes: TmpDataDocentes = {
    docentesPaginacion: {
      pageSize: 100,
      currPage: 1,
      totalPages: 1,
      totalItems: 0
    },
    listado: []
  }
  loadingDocentes: boolean = false
  filteredDocentes: any[] = []
  currDocente: ObjDocente | null = null
  currSeccion: ObjSeccion | null = null
  @ViewChildren(NgSelectComponent) selectComponents!: QueryList<NgSelectComponent>;
  @ViewChild('selectDocente') selectDocente: NgSelectComponent | undefined;
  placeholderDocente: string = 'Ingresar ID o nombre docente'

  constructor(
    private _portalServices: PortalCalificacionesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _utilsFn: UtilsFnService,
    private _perfilamiento: PerfilamientoService,
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.filtros) {
      this.filtrosCargados = routerData.filtros
    }
    this.obtenerAnyos()
  }

  displayFnCodDocentes(docente: any): string {
    return docente?.codigo ?? ''
  }

  displayFnNombreDocentes(docente: any): string {
    return docente?.primerNombre ? `${docente?.primerNombre ?? ''} ${docente?.apellidoPat ?? ''} ${docente?.apellidoMat ?? ''}` : ''
  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '')
  }

  resetearValidacion(tipo: string = 'default') {
    this.submitted = false
    this.tieneErrores["anyo"] = false
    this.tieneErrores["periodo"] = false
  }

  fnCasePeriodo(): void {
    this.obtenerSedes(this.filtroAnyo, this.filtroPeriodo, 0);
  }
  
  fnCaseSede(): void {
    this.limpiarFiltroSecciones(true)
    this.limpiarFiltroDocentes(true)
    this.obtenerSecciones(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, 0);
    if ( this.filtroSede !== 0 ) {
      this.verificarYObtenerDocentesParaSedeDos();
    }
  }
  
  // Eliminar?
  verificarYObtenerDocentesParaPeriodoDos(): void {
    if (Object.keys(this.filtrosCargados).length === 0 || (!this.filtrosCargados?.periodoId && this.filtrosCargados?.sedeId === 0)) {
      this.obtenerDocentesDos(this.filtroAnyo, this.filtroPeriodo);
    }
  }

  verificarYObtenerDocentesParaSedeDos(): void {
    this.obtenerDocentesDos(this.filtroAnyo, this.filtroPeriodo, this.filtroSede);

    
  }

  cargarFiltros(filtro: string): void {
    if ( this.filtroAnyo === 0 && this.filtroPeriodo === 0 ) {
      return
    }

    switch (filtro) {
      case "anyo":
        this.obtenerPeriodosDos(this.filtroAnyo)
        break;
      case "periodo":
        this.fnCasePeriodo()
        break;
      case "sede":
        this.fnCaseSede()
        break;
      case "seccion":
        this.obtenerDocentesDos(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, this.filtroSeccion ?? 0)
        break;
      default:
        break;
    }
  }

  obtenerAnyos() {
    this._portalServices.obtenerListaAnhos(this._perfilamiento.getUsuario().tipoUsuario === 'Backoffice').subscribe((res: IAnyos) => {
      this.listaAnyo = res.anyos
      if ( this.filtrosCargados?.anyo ) {
        this.filtroAnyo = this.filtrosCargados?.anyo
        delete this.filtrosCargados.anyo
        this.cargarFiltros('anyo')
      }
    })
  }

  obtenerDocentesDos(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0): void {
    this.loadingDocentes = true
    this._portalServices.obtenerListaDocentesBackoffice(anyo, periodoId, sedeId, seccionId ?? 0, this.docentesPaginacion.currPage, this.docentesPaginacion.pageSize).subscribe((res: any) => {
      this.loadingDocentes = false
      this.listaNombreDocentes = res
      this.filteredDocentes = [...this.listaNombreDocentes.listado];  // Lista filtrada

      this.docentesPaginacion.currPage = res.currentPage
      this.docentesPaginacion.totalItems = res.totalItems
      this.docentesPaginacion.totalPages = res.totalPages

      this.tmpDocentes = {
        docentesPaginacion: this.docentesPaginacion,
        listado: [...this.listaNombreDocentes.listado],
      }

      if ( this.filtrosCargados?.dataDocente ) {
        this.currDocente = this.filtrosCargados.dataDocente
        this.filtroIdDocente = this.filtrosCargados.dataDocente.codigo

        const setDocente: any = { ...this.filtrosCargados.dataDocente }
        this.listaNombreDocentes.listado = [setDocente]
        this.filteredDocentes = [...this.listaNombreDocentes.listado];  // Lista filtrada
        delete this.filtrosCargados.dataDocente
      }

      if ( !this.filtrosCargados?.dataDocente && this.listaNombreDocentes?.listado?.length === 1 ) {
        this.currDocente = this.listaNombreDocentes.listado[0]
        this.filtroIdDocente = this.listaNombreDocentes.listado[0].codigo
      }
    })
  }

  obtenerPeriodosDos(filtroAnyo: number): void {
    this.filtroPeriodo = 0
    this.filtroSeccion = undefined
    this.filtroSede = 0
    this.listaSede = []
    this.listaSeccion = []

    if ( filtroAnyo !== 0 ) {
      this.tieneErrores["anyo"] = false
      const administrativo: any = this._perfilamiento.getUsuario().tipoUsuario === 'Backoffice'
      this._portalServices.obtenerListaPeriodos(filtroAnyo, administrativo).subscribe(
        (res: IPeriodos) => {
          this.listaPeriodo = res.periodos
          if (this.filtrosCargados?.periodoId) {
            this.filtroPeriodo = this.filtrosCargados.periodoId
            delete this.filtrosCargados.periodoId
            this.cargarFiltros('periodo')
          }
        }
      )
    }
  }

  obtenerSedes(anyo: number = 0, periodoId: number = 0, funcionarioId: number = 0) {
    this.filtroSeccion = undefined
    this.filtroSede = 0
    this.listaSede = []
    this.listaSeccion = []
    this._portalServices.obtenerListaSedesBackoffice(anyo, periodoId, funcionarioId).subscribe((res: any) => {
      this.listaSede = res
      if (this.filtrosCargados?.sedeId) {
        this.filtroSede = this.filtrosCargados.sedeId
        delete this.filtrosCargados.sedeId
        this.cargarFiltros('sede')
      }
    })
  }

  obtenerSecciones(anyo: number = 0, periodoId: number = 0, sedeId: number = 0, docenteId: number = 0) {
    this.loadingSecciones = true
    this._portalServices.obtenerListaSeccionesBackoffice(anyo, periodoId, sedeId, docenteId, this.seccionesPaginacion.currPage, this.seccionesPaginacion.pageSize).subscribe((res: ISeccionesRes) => {
      this.loadingSecciones = false
      this.listaSeccion = res
      this.seccionesPaginacion.totalPages = res.totalPages
      this.seccionesPaginacion.currPage = res.currentPage
      this.seccionesPaginacion.totalItems = res.totalItems

      // copia de filtro docente
      this.tmpSecciones = {
        seccionesPaginacion: this.seccionesPaginacion,
        listado: [...this.listaSeccion.listado],
      }

      if ( this.filtrosCargados?.dataSeccion ) {
        this.currSeccion = this.filtrosCargados.dataSeccion
        this.filtroSeccion = this.filtrosCargados.seccionId

        const setSeccion: any = { ...this.filtrosCargados.dataSeccion }
        this.listaSeccion.listado = [setSeccion]
        delete this.filtrosCargados.dataSeccion
      }
      // Fin copia de filtro docente
    })
  }

  // cambios filtro secciones
  limpiarFiltroSecciones(forced: boolean = false): void {
    if ( forced ) {
      this.filtroSeccion = undefined
      this.listaSeccion = []
      this.tmpSecciones = {
        seccionesPaginacion: {
          pageSize: 500,
          currPage: 1,
          totalPages: 1,
          totalItems: 0
        },
        listado: []
      }
    }
    if ( this.tmpSecciones.listado.length > 0 || forced ) {
      this.listaSeccion.listado = this.tmpSecciones.listado
      this.seccionesPaginacion = this.tmpSecciones.seccionesPaginacion
  
      this.tmpSecciones.listado = []
    }
    this.searchValueSecciones = ''
  }

  onSearchSecciones(term: any): void {
    this.searchValueSecciones = term.term;
    
    if ( term.term.length === '' ) {
      this.limpiarFiltroSecciones()
      this.currSeccion = null
    }

    if ( (term.term.length > 3 || term.items.length === 0) && (this.listaSeccion?.listado?.length < this.seccionesPaginacion.totalItems) ) {
      if ( this.tmpSecciones.listado.length === 0 ) {
        this.tmpSecciones = {
          seccionesPaginacion: this.seccionesPaginacion,
          listado: this.listaSeccion.listado
        }
      }

      // buscar en servicio
      let reqParams: ISeccionesReq = {
        anyo: this.filtroAnyo, 
        periodoId: this.filtroPeriodo, 
        sedeId: this.filtroSede,
        docenteId: 0,
        pageNo: undefined,
        pageSize: 500,
        search: term.term.toUpperCase()
      }

      this.obtenerSeccionesPaging(reqParams)
    }
  }

  onItemChangeSecciones(event: any): void {
    this.limpiarFiltroDocentes(true)
    if ( event ) {
      this.currSeccion = event
      this.obtenerDocentesDos(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, this.filtroSeccion ?? 0)
    } else {
      this.currSeccion = null
    }
  }

  onClearSecciones(event: any): void {
    this.limpiarFiltroSecciones()
    this.obtenerDocentesDos(this.filtroAnyo, this.filtroPeriodo, this.filtroSede, this.filtroSeccion ?? 0)
  }

  endScrollSecciones(term: any): void {
    let reqParams: ISeccionesReq = {
      anyo: this.filtroAnyo, 
      periodoId: this.filtroPeriodo, 
      sedeId: this.filtroSede,
      docenteId: 0,
      pageNo: (this.seccionesPaginacion.currPage ?? 1) + 1,
      pageSize: this.seccionesPaginacion.pageSize,
    }
    if ( (this.seccionesPaginacion.currPage < this.seccionesPaginacion.totalPages) && term === '' ) {
      this.obtenerSeccionesPaging(reqParams)
    }
  }

  obtenerSeccionesPaging(params: ISeccionesReq) {
    this.loadingSecciones = true
    this._portalServices.obtenerListaSeccionesBackoffice(params.anyo, params.periodoId, params.sedeId, params.docenteId, params.pageNo, params.pageSize, params.search).subscribe((res: ISeccionesRes) => {
      this.loadingSecciones = false
      if ( params.search ) {
        this.listaSeccion.listado = []
      } else {
        this.seccionesPaginacion.currPage = res.currentPage
        this.seccionesPaginacion.totalItems = res.totalItems
        this.seccionesPaginacion.totalPages = res.totalPages
      }

      this.listaSeccion.listado = [...this.listaSeccion.listado, ...res.listado]
    })
  }
  // fin cambio filtro secciones

  // Cambio filtro docentes
  limpiarFiltroDocentes(forced: boolean = false): void {
    if ( forced ) {
      this.filtroIdDocente = undefined
      this.filteredDocentes = []
      this.tmpDocentes = {
        docentesPaginacion: {
          pageSize: 100,
          currPage: 1,
          totalPages: 1,
          totalItems: 0
        },
        listado: []
      }
    }
    if ( this.tmpDocentes.listado.length > 0 || forced ) {
      this.filteredDocentes = this.tmpDocentes.listado
      this.listaNombreDocentes.listado = this.tmpDocentes.listado
      this.docentesPaginacion = this.tmpDocentes.docentesPaginacion
    }
    this.searchValueDocentes = ''
    this.currDocente = null
  }

  onItemChangeDocentes(event: any, element: any): void {
    element.searchInput.nativeElement.value = ''
    this.searchValueDocentes = ''

    if ( event ) {
      this.currDocente = event
    } else {
      this.currDocente = null
      this.placeholderDocente = 'Ingresar ID o nombre docente'
      if ( this.listaNombreDocentes?.listado ) {
        this.filteredDocentes = [...this.listaNombreDocentes.listado]; // data local funcionando
      }

      if ( this.tmpDocentes?.listado?.length > 0 ) {
        this.filteredDocentes = this.tmpDocentes.listado
        this.listaNombreDocentes.listado = this.tmpDocentes.listado
        this.docentesPaginacion = this.tmpDocentes.docentesPaginacion
      }
    }
  }

  onClearDocentes(event: any): void {
    this.limpiarFiltroDocentes()
  }

  cstmSearchDocente(term: any) {
    if (term.term === '') {
      this.currDocente = null
      this.placeholderDocente = 'Ingresar ID o nombre docente'

      if ( this.listaNombreDocentes?.listado ) {
        this.filteredDocentes = [...this.listaNombreDocentes.listado]; // Restablecer si no hay término de búsqueda
      }
    } else {
      this.filteredDocentes = this.listaNombreDocentes?.listado?.filter((item: any) => {
        const fullName = `${item.primerNombre} ${item.apellidoPat} ${item.apellidoMat}`.toLowerCase();
        return (
          item.primerNombre.toLowerCase().includes(term.term) ||
          item.apellidoPat.toLowerCase().includes(term.term) ||
          item.codigo.includes(term.term) || 
          fullName.includes(term.term)
        );
      });
      const secondSelect = this.selectComponents.toArray()[1];
      if (secondSelect) {
        this.placeholderDocente = ''
        secondSelect.close(); // Cierra el segundo ng-select (Necesario para actualizar items custom)
      }
    }
  }

  onSearchDocentes(term: any): void {
    this.searchValueDocentes = term.term

    // Busqueda custom
    this.cstmSearchDocente(term)

    if ( term.term === '' && this.tmpDocentes?.listado?.length > 0 ) {
      this.limpiarFiltroDocentes()
    }

    // Busqueda desde servicio
    if ( (term.term.length > 3 || this.filteredDocentes?.length === 0) && (this.listaNombreDocentes?.listado?.length < this.docentesPaginacion.totalItems) ) {
      // buscar en servicio
      let reqParams: IDocentesReq = {
        anyo: this.filtroAnyo, 
        periodoId: this.filtroPeriodo, 
        sedeId: this.filtroSede,
        seccionId: this.filtroSeccion ?? 0,
        pageNo: undefined,
        pageSize: 500,
        search: term.term
      }

      this.obtenerDocentesPaging(reqParams, term)
    } 
  }

  endScrollDocentes(term: any): void {
    let reqParams: IDocentesReq = {
      anyo: this.filtroAnyo, 
      periodoId: this.filtroPeriodo, 
      sedeId: this.filtroSede,
      seccionId: this.filtroSeccion ?? 0,
      pageNo: (this.docentesPaginacion.currPage ?? 1) + 1,
      pageSize: this.docentesPaginacion.pageSize,
    }
    if ( (this.docentesPaginacion.currPage < this.docentesPaginacion.totalPages) && term === '' ) {
      this.obtenerDocentesPaging(reqParams)
    }
  }

  obtenerDocentesPaging(params: IDocentesReq, term?: any) {
    this.loadingDocentes = true
    this._portalServices.obtenerListaDocentesBackoffice(params.anyo, params.periodoId, params.sedeId, params.seccionId, params.pageNo, params.pageSize, params.search).subscribe((res: any) => {
      this.loadingDocentes = false
      if ( params.search ) {
        this.listaNombreDocentes.listado = []
        // this.filteredDocentes = []
      } else {
        this.docentesPaginacion.currPage = res.currentPage
        this.docentesPaginacion.totalItems = res.totalItems
        this.docentesPaginacion.totalPages = res.totalPages

        // Guardado lista cuando no hay busqueda
        this.tmpDocentes = {
          docentesPaginacion: this.docentesPaginacion,
          listado: [...this.listaNombreDocentes.listado, ...res.listado],
        }
      }

      this.listaNombreDocentes.listado = [...this.listaNombreDocentes.listado, ...res.listado]
      this.filteredDocentes = [...this.listaNombreDocentes.listado];
    })
  }
  // Fin cambio filtro docentes

  navToPortalDocente() {
    this.router.navigate(['/portal-calificacion'], {
      state: {
        data: {
          filtros: {
            anyo: this.filtroAnyo,
            periodoId: this.filtroPeriodo,
            sedeId: this.filtroSede,
            docenteId: this.currDocente?.funcionarioId, // 14599215
            seccionId: this.filtroSeccion ?? 0,
            dataDocente: this.currDocente,
            dataSeccion: this.currSeccion
          }
        }
      }
    })
  }

  camposRequeridos() {
    return this.filtroAnyo !== 0 && this.filtroPeriodo !== 0 && this.filtroSede !== 0 && this.filtroIdDocente !== undefined
  }

}
